"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

import { Button } from "@/components/ui/button";

import { handleError, type HandleErrorOptions } from "@/helper/error";
import { getAppUrl } from "@/helper/url";

interface ErrorProps extends Pick<HandleErrorOptions, "error"> {
  reset: () => void;
}

export default function GlobalError({ error, reset }: ErrorProps) {
  const pathname = usePathname();

  useEffect(() => {
    handleError({
      error,
      pathname: `${getAppUrl()}${pathname}`,
      errorType: "GlobalError",
    }).catch(console.error);
  }, [error, pathname]);

  return (
    <html>
      <body>
        <div className="flex flex-col gap-3 items-center justify-center h-[100vh] p-4">
          <h1 className="text-4xl font-bold text-center">Algo deu errado!</h1>
          <h2 className="text-center text-base text-muted-foreground max-w-md">
            Nosso time já foi avisado e estamos atuando para corrigir o
            problema. Tente novamente mais tarde.
          </h2>
          <Button variant="outline" onClick={reset}>
            Atualizar página
          </Button>
        </div>
      </body>
    </html>
  );
}
